import React, { useState } from "react"
import Accordion from "../../components/Accordion"
import Sticky from 'react-sticky-el'
import { SocialIcon } from 'react-social-icons'

import {
    Container,
    Row,
    Col,
    Card,
    CardText,
    CardImg,
    CardBody,
    CardTitle,
    Collapse,
    Navbar,
    NavbarToggler,
    Nav,
    NavItem,
    NavLink,
    NavbarBrand 

} from 'reactstrap'

import JourneySlider from "../../components/Slider"

export default function PrimeTimeVC(props) {


    const changeImage = (event) => {

        var _id = event.target.parentNode.id

        if (_id === "") {
            _id = event.target.parentNode.parentNode.id

        }

        document.getElementById('videoPlaceholder').style.display = "none";
        document.getElementById('player_id').src = "";
        document.getElementById('imgPlaceholder').style.display = "block";        

        switch (_id) {
            
            case "imageOne":
                document.getElementById('imgPlaceholder').src = "/img/contestants.png";
                break;
            case "imageTwo":

                document.getElementById('imgPlaceholder').src = "/img/topics.png";
                break;
            case "imageThree":

                document.getElementById('imgPlaceholder').src = "/img/points.png";
                break;
            case "imageFour":
                document.getElementById('videoPlaceholder').style.display = "block";
                document.getElementById('player_id').src = "https://www.youtube.com/embed/Xq_jEUqXnPE";
                document.getElementById('imgPlaceholder').style.display = "none";
                break;
            case "imageFive":
                document.getElementById('imgPlaceholder').src = 'img/camera-placement.png';
                break;
            default:
                break;
        }
    }

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    return (
        <div>
            <Container>
                <div className={'navigation-container'}>
                    <Navbar color="light" light expand="md">
                        <NavbarBrand href="/">
                            <img 
                                className='logo logo-resize'
                                src="/img/ptvc-logo-long.png" />
                        </NavbarBrand>
                        {/*<NavbarToggler onClick={toggle} />*/}
                        <Collapse isOpen={isOpen} navbar>
                            <Nav className="mr-auto" navbar>
                            </Nav>
                        </Collapse>
                        <div className='pull-right company-type-icons d-none d-lg-block'>
                            <span><img src="/img/money.png" />Venture Capital</span>
                            <span><img src="/img/tech.png" />Tech</span>
                            <span><img src="/img/startup.png" />Startups</span>
                            <span><img src="/img/stonks.png" />Business</span>
                            <span><img src="/img/education.png" />Education</span>
                        </div>
                    </Navbar>
                </div>
                <section id={"hero"} className={'hero'}>
                    <Row>
                        <Col lg="5">
                            <div className={'heading-container'}>
                                <label className={"pre-heading"}>INTRODUCTION</label>
                                <h1 className={"heading"}> WELCOME TO PrimeTime VC,</h1>
                                <h1 className={"show-quote"}>"The Show of Accredited Banter"</h1>
                                <p className={"heading-subtext"}>Where the best in venture capital compete and debate the latest topics in tech, innovation and funding news.</p>
                                <a href="https://techcrunch.com/2020/09/23/primetime-vc-venture-capitalists-are-going-on-a-gameshow-of-accredited-banter/?tpcc=ECTW2020" className={"pre-heading"}>
                                    As seen on TechCrunch  <img className={'icon-image'} style={{ marginLeft: "8px" }} width="44px" src="/img/techcrunch.png" alt="Card image cap" />
                                </a>
                                <a href="https://docs.google.com/forms/d/1um1zG6FP9uqcfoStSSAcqf7EDD0wc2vH_A7mNzH344w/edit" className={"btn btn-custom d-lg-none"}
                                >
                                    Join The Show!
                  </a>
                            </div>
                        </Col>
                        <Col lg="1"></Col>
                        <Col lg="6">
                            <img className={'video-bg-blob'} src="../img/headerblob.png" />
                            <div className={"embed-responsive embed-responsive-16by9 video-container"}>
                                <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/xB4I-Ruc_c4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </Col>
                    </Row>
                    <Sticky>
                        <div className={"floating-nav d-none d-lg-block"}>
                            <Navbar color="light" light expand="md">
                                <NavbarToggler onClick={toggle} />
                                <Collapse isOpen={isOpen} navbar>
                                    <Nav className="mr-auto" navbar>
                                        <NavItem>
                                            <NavLink href="#bigIdea">Big Idea</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink href="#video">Demo</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink href="#format">Format</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink href="#journey">Journey</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink href="#team">Team</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink href="#sponsor">Sponsor</NavLink>
                                        </NavItem>
                                        
                                        
                                    </Nav>
                                    <a href="https://forms.gle/oXEhGM9URpR6np8C6" target="_blank" className={'btn btn-primary btn-custom'}>Join the Show</a>
                                </Collapse>
                            </Navbar>
                        </div>
                    </Sticky>
                </section>

            </Container>
            <Container>
                <section id={"bigIdea"} className={'big-idea '}>
                    <Row>
                        <Col lg="6">
                            <div className={'heading-container'}>
                                <label className={"pre-heading"}>THE BIG IDEA</label>
                                <h1 className={"heading text-capitalize"}>Bring together the best in venture capital to compete and debate</h1>
                                <p className={"heading-subtext"}>Access to valuable insights for Venture Capital, Tech, and Business is trapped in either dry and overly nuanced content making the barrier to entry high for the audience or it’s watered down and too focused on entertainment so that the audience is not challenged.</p>
                            </div>
                        </Col>
                        <Col lg="6">
                            <Row>
                                <Col lg="6">
                                    <Card className={'card-middle'}>
                                        <img className={'icon-image'} width="100px" src="/img/ico_01.png" alt="Card image cap" />
                                        <CardBody>
                                            <CardTitle>Game Format</CardTitle>
                                            <CardText>We’ve used the outline of ESPN’s show Around The Horn to create a fun and engaging platform for VC’s to present their opinions on what’s trending in venture capital, tech, and business. </CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col lg="6">
                                    <Card>
                                        <img className={'icon-image'} width="100px" src="/img/ico_02.png" alt="Card image cap" />
                                        <CardBody>
                                            <CardTitle>Competition</CardTitle>
                                            <CardText>Light competition drives deeper insights and nuance to complex topics while keeping a high energy environment.</CardText>
                                        </CardBody>
                                    </Card>
                                    <Card>
                                        <img className={'icon-image'} width="100px" src="/img/ico_03.png" alt="Card image cap" />
                                        <CardBody>
                                            <CardTitle>Education</CardTitle>
                                            <CardText>Our programming is designed to not only be entertaining but inform and educate a broader audience of people that want to learn about the venture capital industry.</CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>
            </Container>
            <Container>
                <section id={"video"} className={'big-idea '}>
                    <Row>
                        <Col lg="6">
                            <img className={'video-bg-blob'} src="../img/headerblob.png" />
                            <div className={"embed-responsive embed-responsive-16by9 video-container"}>
                                <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/D5bkxLaaGQQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </Col>
                        
                        <Col lg="1"></Col>
                        <Col lg="5">
                            <div className={'heading-container'}>
                                <label className={"pre-heading"}>DEMO VIDEO</label>
                                <h1 className={"heading"}> Watch Our Demo Video</h1>
                                <p className={"heading-subtext"}>Investors go head-to-head as we talk about the latest and greatest happening in tech.</p>
                                <a href="https://docs.google.com/forms/d/1um1zG6FP9uqcfoStSSAcqf7EDD0wc2vH_A7mNzH344w/edit" className={"btn btn-custom d-lg-none"}
                                >
                                  Join The Show!
                  </a>
                            </div>
                        </Col>
                    </Row>
                </section>
            </Container>
            <Container>
                <section id={"format"} className={'product-business-model '}>
                    <Row>
                        <Col lg='6' className="">
                            <img className={"img-responsive product-img rounded"} id="imgPlaceholder" src="/img/contestants.png"></img>
                            <div className={"embed-responsive embed-responsive-16by9 video-container product-video"} id="videoPlaceholder">
                                <iframe class="embed-responsive-item" id="player_id" src="https://www.youtube.com/embed/D5bkxLaaGQQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; " allowfullscreen></iframe>    
                            </div>
                        </Col>
                        <Col lg='6'>
                            <div className={'heading-container'}>
                                <label className={"pre-heading"}>FORMAT</label>
                                <h1 className={"heading"}>New Generation of Business Education and Entertainment</h1>
                            </div>
                            <Accordion open={0} onClick={changeImage}>
                                <Accordion.Item>
                                    <Accordion.Header id="imageOne" >
                                        <span className={'caret-container'}>
                                            <span className={'caret'}></span>
                                        </span>
                                          Contestants
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Four Venture Capitalists square off in each episode with Moderator, Charlie Stephens. </p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item>
                                    <Accordion.Header id="imageTwo" >
                                        <span className={'caret-container'}>
                                            <span className={'caret'}></span>
                                        </span>
                                          Topics
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>The hottest tech and business news of the past two weeks are compressed into three debate sections: First In, Buy or Sell and The Money Round. Each VC gets their uninterrupted time to provide their take on the given question along with time for rebuttals.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item>
                                    <Accordion.Header id="imageThree" >
                                        <span className={'caret-container'}>
                                            <span className={'caret'}></span>
                                        </span>
                                        Point System
                                </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Scoring is based on Point of View, Style and Information. VC's will be rewarded +1 point for a good answer , +2 points for a great answer and +3 for use of props. Points are taken away for running over the allotted time or an egregious brag. </p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item>
                                    <Accordion.Header id="imageFour" >
                                        <span className={'caret-container'}>
                                            <span className={'caret'}></span>
                                        </span>
                                          Winning Monologue
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>The winner of the showdown and therefore the winner of that particular episode gets one minute to talk about anything he or she wishes to discuss. This could be a personal investment story, their firm’s investment thesis, or an opinion on a pressing issue within the VC community.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item>
                                    <Accordion.Header id="imageFive" >
                                        <span className={'caret-container'}>
                                            <span className={'caret'}></span>
                                        </span>
                                          Recording Requirements
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Each episode will be recorded on ZOOM for 40 minutes with all the participants. The VC’s will receive the question topics beforehand which we suggest they review prior to the ZOOM call. </p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                </section>
            </Container>
            <Container>
                <section id={"journey"} className={'journey'}>
                    <Row>
                        <Col lg="8">
                            <div className={'heading-container'}>
                                <label className={"pre-heading"}>OUR JOURNEY</label>
                                <h1 className={"heading"}>PrimeTime VC is off to a great start!</h1>
                            </div>
                        </Col>
                        <Col lg="4">

                        </Col>
                    </Row>
                    <br />
                    <JourneySlider />
                </section>
            </Container>
            <Container fluid>
                <section id={"team"} className={'team'}>
                    <Container>
                        <Row>
                            <Col>
                                <div className={'heading-container text-center'}>
                                    <label className={"pre-heading"}>A SHARED MISSION</label>
                                    <h1 className={"heading"}>An Incredible Team With a Shared Mission</h1>
                                    <h2 className={"heading-2"}>"Bringing together the best minds in venture capital through light competition and debate that’s palatable for a broader audience to better educate themselves across business, tech, and investing."</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row className={"team-img-container"}>
                            <Col lg="4" xs="6">
                                <Card>
                                    <CardImg top width="100%" src="/img/tyler.png" alt="Card image cap" />
                                    <CardBody>
                                        <CardTitle className="card-title">Tyler Kelly <a href="https://www.linkedin.com/in/tyler-kelly-0b97955a/"><img src="img/linkedin-logo.png" width="15px"></img></a></CardTitle>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="4" xs="6">
                                <Card>
                                    <CardImg top width="100%" src="/img/charley.png" alt="Card image cap" />
                                    <CardBody>
                                        <CardTitle className="card-title">Charlie Stephens <a href="https://www.linkedin.com/in/charliestephens/"><img src="img/linkedin-logo.png" width="15px"></img></a></CardTitle>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="4" xs="6">
                                <Card>
                                    <CardImg top width="100%" src="/img/nidal.png" alt="Card image cap" />
                                    <CardBody>
                                        <CardTitle className="card-title">Nidal Harvey <a href="https://www.linkedin.com/in/nidal-qannari-harvey/"><img src="img/linkedin-logo.png" width="15px"></img></a></CardTitle>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Container>
            <Container>
                <section id={"sponsor"} className={'sponsor'}>
                    <Row>
                         <Col>
                            <div className={'heading-container'}>
                                <label className={"pre-heading"}>Sponsorships</label>

                                <h1 className={"heading"}>Sponsor Or</h1>
                                <h1 className={"heading"}>Partner With Us</h1>
                                <p className={"heading-subtext"}></p>
                            </div>
                      </Col>
                    </Row>
                    <Row>
                        <Col className="order-xs-0">
                            <Card className={'stat-card order-xs-2'}>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <div className={'stat-number'}>Championship</div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className={'stat-number'}>Sponsor</div>
                                        </Col>
                                    </Row>
                                    <Row className="price-margin">
                                        <Col lg="4" xs="12">
                                            <div className='stat-title'>$1500</div>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col lg="4">
                                                    <p className={'stat-description'}>Per Episode</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <CardText className="list-title">Includes:
                                                <ul className="stat-description">
                                                    <li>Sponsored question that VC’s debate during the episode</li>
                                                    <li>Moderator shoutout during the episode </li>
                                                    <li>Full page company logo displayed at beginning and end of episode</li>
                                                    <li>Inclusion in a minimum of four additional video clips per episode</li>
                                                    <li>Inclusion in all social media posts and newsletter (10K subs)</li>
                                                </ul>
                                            </CardText>
                                        </Col>
                                    </Row>
                                </CardBody>
                                <Row>
                                    <Col>
                                        <a href="mailto:tyler@pitchmadness.com?cc=charlie@charlienyc.com&subject=PrimeTimeVC:%20Championship%20Sponsor" target="_blank" className={'btn btn-primary btn-custom w-100 button-red'}>Become a Championship Sponsor</a>
                                    </Col>
                                </Row>
                            </Card>
                            <Card className={'stat-card order-xs-0'}>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <div className={'stat-number'}>Startup</div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className={'stat-number'}>Package</div>
                                        </Col>
                                    </Row>
                                    <Row className='price-margin'>
                                        <Col lg="4">
                                            <div className='stat-title'>$250</div>
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col lg="4">
                                                    <p className={'stat-description'}>Per Episode</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <CardText className="list-title">Includes:
                                                <ul className="stat-description">
                                                    <li>Moderator shoutout during the episode</li>
                                                    <li>Intro of your startup to the VC’s in the episode</li>
                                                    <li>Logo inclusion on sponsor page</li>
                                                    <li>Inclusion in a minimum of two additional video clips per episode</li>
                                                    <li>Inclusion in all social media and newsletter (10K subs)</li>
                                                </ul>
                                            </CardText>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <a href="mailto:tyler@pitchmadness.com?cc=charlie@charlienyc.com&subject=PrimeTimeVC:%20Startup%20Package%20" target="_blank" className={'btn btn-primary btn-custom w-100 button-red'}>I Want the Startup Package</a>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="6" xs="12" >
                            <Card className={'stat-card research-card-spacing mt-n5 order-xs-3'}>
                            <CardBody>
                                <Row>
                                    <Col>
                                    <div className={'stat-number'}>Final Four</div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                    <div className={'stat-number'}>Sponsor</div>
                                    </Col>
                                </Row>
                                <Row className='price-margin'>
                                <Col lg="4">
                                    <div className='stat-title'>$500</div>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col lg="4">
                                        <p className={'stat-description'}>Per Episode</p>
                                        </Col>
                                    </Row>
                                </Col>
                                </Row>
                                <Row>
                                <Col>
                                    <CardText className="list-title">Includes:
                                    <ul className="stat-description">
                                        <li>Moderator shoutout during the episode</li>
                                        <li>Logo inclusion on sponsor page</li>
                                        <li>Inclusion in a minimum of two additional video clips per episode</li>
                                        <li>Inclusion in all social media and newsletter (10K subs)</li>
                                    </ul>
                                    </CardText>
                                </Col>
                                </Row>
                                <Row>
                                <Col>
                                    <a href="mailto:tyler@pitchmadness.com?cc=charlie@charlienyc.com&subject=PrimeTimeVC:%20Final%20Four%20Sponsor" target="_blank" className={'btn btn-primary btn-custom w-100 button-red'}>Become a Final Four Sponsor</a>
                                </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className={'stat-card order-xs-3'}>
                            <CardBody>
                                <Row>
                                    <Col>
                                        <div className={'stat-number'}>Strategic</div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className={'stat-number'}>Partnerships</div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href="mailto:tyler@pitchmadness.com?cc=charlie@charlienyc.com&subject=PrimeTimeVC:%20Let's%20Partner" target="_blank" className='stat-title'>Contact Us</a>
                                    </Col>
                                </Row>
                                <CardText className="list-title">We are always looking for:
                                    <ul className="stat-description">
                                        <li>
                                            New opportunities to collaborate and cross-promote with well aligned individuals and organizations that can help us build PrimeTimeVC
                                        </li>
                                    </ul>
                                <CardText className="stat-description">
                                    If you have a newsletter or platform that you think fits with our audience please contact: 
                                
                                </CardText>
                                <CardText className="stat-description">
                                    <a href="mailto:tyler@pitchmadness.com">Tyler - tyler@pitchmadness.com </a>or <a href="mailto:charlie@charlienyc.com"> Charlie - charlie@charlienyc.com </a>
                                </CardText>
                                    <a href="mailto:tyler@pitchmadness.com?cc=charlie@charlienyc.com&subject=PrimeTimeVC:%20Let's%20Partner" target="_blank" className={'btn btn-primary btn-custom w-100 button-red'}>Email the Team</a>
                                </CardText>    
                            </CardBody>
                        </Card>  
                    </Col>  
                </Row>
              </section>
            </Container>
            <Container>
                <section id={"signup"} className={'signup'}>
                    <div className={'heading-container text-center'}>
                            <Row>
                                <Col>
                                    <label className={"pre-heading"}>CONTACT</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h1 className={"heading"}>Join PrimeTime VC Today</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p className={"heading-quote"}>"The show of accredited banter"</p>
                                </Col>
                            </Row>
                            <Row className="margin-top-2">
                                <Col>
                                <p className={"contact"}><b>Contact us if you’d like to Sponsor a future episode:</b></p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p className="email">
                                        <a href="mailto:tyler@pitchmadness.com"> Tyler Kelly, @tyler@pitchmadness.com </a>
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p className="email">
                                        <a href="mailto:charlie@charlienyc.com">Charlie Stephens, Charlie@charlienyc.com</a>
                                    </p>
                                </Col>
                            </Row>
                            <hr/>
                        
                            <Row>
                                <Col>
                                    <p className="contact margin-top-2">
                                        If you’re a Venture Capitalist, Angel Investor or LP and have interests 
                                    </p>
                                <p className="contact ">
                                    in participating in a future episode, please "Join the Show"
                                </p>
                                <a href="https://forms.gle/oXEhGM9URpR6np8C6" target="_blank" className={'btn btn-primary btn-custom'}>Join the Show</a>
                                </Col>
                            </Row>
                        
                        <hr />
                        <Row>
                            <Col>
                                <p className="margin-top-2">
                                    <b>Please support the show by subscribing to our YouTube and Podcast channels.</b>
                                </p>
                            </Col>
                        </Row>

                        <Row className="margin-top-2">
                            <Col xs="4" lg="2 offset-lg-3">
                                <SocialIcon url="https://www.youtube.com/channel/UCbBPkZKkJDO86oLXgIQhhHQ" />
                            </Col>
                            <Col xs="4" lg="2">
                                <SocialIcon url="https://open.spotify.com/show/04AjemUA0mEYgGchaItIHB" />
                            </Col>
                            <Col xs="4" lg="2">
                                <SocialIcon url="https://podcasts.apple.com/us/podcast/primetime-vc/id1532082181" network="itunes" />
                            </Col>
                        </Row>
                    </div>
                </section>
            </Container>
            <Container>
                <section className={'text-center'} id="powered-by">
                    <span>Powered By <a href="https://pitchpages.io/"><img src="/img/temp_logo.png" width="150px" /></a></span>
                </section>
            </Container>
        </div>
    )
}
